import { useState } from 'react'
import { Payload } from 'recharts/types/component/DefaultLegendContent'

export const useLegend = () => {
  const [disease, setDisease] = useState<string | null>(null)
  const [hoveredDisease, setHoveredDisease] = useState<string | null>(null)

  const handleLegendMouseEnter = (e: Payload) => {
    setHoveredDisease((e.dataKey as string) ?? null)
  }

  const handleLegendMouseLeave = () => {
    setHoveredDisease(null)
  }

  const selectLegend = (e: Payload) => {
    if (disease !== (e.dataKey as string)) {
      setDisease((e.dataKey as string) ?? null)
    } else {
      setDisease(null)
    }
  }

  return {
    handleLegendMouseEnter,
    handleLegendMouseLeave,
    selectLegend,
    selectedLegends: Array.from(
      new Set([disease, hoveredDisease].filter((x) => !!x))
    ),
  }
}
